import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import TextButton from 'LuxKit/Button/TextButton'
import Group from 'components/utils/Group'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import PriceRowTaxesAndFees from 'LuxKit/PricePoints/PriceRowTaxesAndFees'
import { getBundleValueUp } from 'lib/bundleAndSave/getBundleValueUp'

import { sum, unique } from 'lib/array/arrayUtils'
import PriceRowPriceCaption from 'LuxKit/PricePoints/PriceRowPriceCaption'
import PriceRowPrice from 'LuxKit/PricePoints/PriceRowPrice'
import PriceRowAgentHubCommission from 'agentHub/components/PriceRowAgentHubCommission'
import PriceRowValueDiscountWithCaption from 'LuxKit/PricePoints/Value/PriceRowValueDiscountWithCaption'
import { useOfferPackagePrice } from 'hooks/Offers/useOfferPrice'

interface Props {
  offer: App.BundleOffer | App.BundleOfferSummary
  pkg: App.BundlePackageWithPrice
}

function HeroBundleAndSaveOfferTilePricing(props: Props) {
  const { offer, pkg } = props
  const intl = useIntl()
  const {
    totalPrice,
    saleUnit,
    totalValue,
    valueOffPercent,
  } = useOfferPackagePrice(pkg, offer)

  const { shouldShowDiscountPercent, shouldShowValue } = getBundleValueUp(offer, pkg)

  const isDiscountPillHidden = offer.isDiscountPillHidden

  const duration = useMemo(() => {
    return sum(pkg.packages, (p) => p.duration)
  }, [pkg.packages])

  const offerLocations = useMemo(() => unique(offer.locations.concat(offer.location)),
    [offer.locations, offer.location])
  const vendorName = offer.vendorName

  return (
    <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="end">
      <Group direction="vertical">
        <PriceRowPriceCaption>
          {intl.formatMessage(
            {
              id: '4H0TMecKsl_EikCc4rLe',
              defaultMessage: '{count, plural, one {# night} other {# nights}}, 2 hotels from',
            },
            { count: duration },
          )}
        </PriceRowPriceCaption>
        <PriceRowPrice
          size="L"
          price={Math.ceil(totalPrice)}
          saleUnit={saleUnit}
        />
        <PriceRowTaxesAndFees />
        {shouldShowValue && <PriceRowValueDiscountWithCaption
          size="L"
          originalValue={Math.ceil(totalValue)}
          discountPercentage={shouldShowDiscountPercent && !isDiscountPillHidden ? valueOffPercent : undefined}
        />}
      </Group>
      <PriceRowAgentHubCommission
        productType={offer.productType}
        offerId={offer.id}
        offerLocations={offerLocations}
        vendorName={vendorName}
        packageId={pkg.id}
      />
      <CSSBreakpoint min="desktop">
        <TextButton kind="primary">
          {intl.formatMessage({
            id: 'u-HoVbtZA3d_oHE8gzaT',
            defaultMessage: 'View offer',
          })}
        </TextButton>
      </CSSBreakpoint>
    </Group>
  )
}

export default HeroBundleAndSaveOfferTilePricing
